module.exports = __webpack_public_path__ + "static/media/sidebar-background.3dd877fe.png";